import React from "react";
import { Outlet } from "react-router-dom";
import './ndot.scss';

const NDOTOutlet = () => {
    return (
        <div className="ndot">
            <Outlet />
        </div>
    )
}

export default NDOTOutlet;